const STORAGE_KEY = 'ddv:aiChat:chatbotChatId';

/**
 * @returns {string | null}
 */
export function readChatbotChatId() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (typeof raw !== 'string') {
      return null;
    }
    const chatId = raw.trim();
    return chatId || null;
  } catch {
    return null;
  }
}

/**
 * @param {string} chatId
 */
export function writeChatbotChatId(chatId) {
  const id = (chatId || '').trim();
  if (!id) {
    return;
  }
  try {
    window.localStorage.setItem(STORAGE_KEY, id);
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearChatbotChatId() {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** Headers for common-service logout so backend can revoke the chat ticket. */
export function getChatbotChatIdLogoutHeaders() {
  const chatId = readChatbotChatId();
  if (!chatId) {
    return {};
  }
  return { chatID: chatId };
}
